import styled from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

export default {
  AlertMessage: styled.div`
    ${DEEP_BORDER_BOX}
    direction: ${props => (props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
    display: flex;
  `,
  AlertBar: styled.div`
    ${DEEP_BORDER_BOX}
    direction: ${props => (props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
    height: ${Tokens.SPACING.SPACING_8};
    min-height: ${Tokens.SPACING.SPACING_8};
    background-color: ${props => props.$theme};
    width: 100%;
    border-radius: ${Tokens.RADIUS.RADIUS_2} ${Tokens.RADIUS.RADIUS_2} ${Tokens.RADIUS.RADIUS_0} ${Tokens.RADIUS.RADIUS_0};
  `,
  AlertDetailsHeader: styled.div`
    ${DEEP_BORDER_BOX}
    direction: ${props => (props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: ${Tokens.SPACING.SPACING_12} ${Tokens.SPACING.SPACING_24}
  `
};
